<div class="modal-header w-100">
    <div class="row w-100">
        <div class="col-md-6" [ngSwitch]="calculationType" disabled="TypeDisabled">
            <div *ngSwitchCase="0">
                <h4>{{ 'PLANT_MANAGER.STANDARD_FLANGE' | transloco }}</h4>
            </div>
            <div *ngSwitchCase="1">
                <h4>{{ 'PLANT_MANAGER.CUSTOM_FLANGE' | transloco }}</h4>
            </div>
            <div *ngSwitchCase="2">
                <h4>{{ 'PLANT_MANAGER.CLAMP' | transloco }}</h4>
            </div>
            <div *ngSwitchCase="3">
                <h4>{{ 'PLANT_MANAGER.ENGINEERED_JOINT' | transloco }}</h4>
            </div>
        </div>
        <div class="col-md-6">
            <div class="code_details_title" *ngIf="selectedTaggedItem">
                <div class="title-wrap">
                    <h4>
                        <span class="UniqueId">
                            {{ selectedTaggedItem?.namePrimary ? selectedTaggedItem?.namePrimary : '' }}
                        </span>
                    </h4>
                </div>
                <a class="" href="javascript:void()" ngbAutofocus (click)="closeClick()"><i class="flaticon2-cross close-icon"></i> </a>
            </div>
        </div>
    </div>
</div>
<div class="modal-body output-lable activity_body">
    <div class="container-fluid">
        <div class="row">
            <div class="col-md-4">
                <mat-label class="font-style" [ngbTooltip]="boltType_tooltip" placement="right" container="body" tooltipClass="custom-tooltip">
                    <!-- Bolt Type -->
                    Tool Selection
                </mat-label>
            </div>
            <div class="col-md-8">
                <!-- <mat-form-field class="example-full-width no-line" appearance="outline">
                  <mat-select formControlName="tool" class="input-select" placeholder="Select Tool">
                    <ng-container >
                      <mat-option class="drop-options" value="{{ item.idmsPassPercentageForm}}" *ngFor="let item of toolsData"> {{ item.manufacturer.name}} - {{item.name }} </mat-option>
                    </ng-container>
                  </mat-select>
                </mat-form-field> -->
                <ng-template #boltType_tooltip>
                    <p>
                        {{ 'TOOLTIP.INFORMATE_CALC_LABELS.BOLT_TYPE' | transloco }}
                    </p>
                </ng-template>
                <!--tool-tip template end-->
                <mat-select [(ngModel)]="selectedToolId" name="selectedTool" class="input-select" panelClass="dropdown-wrapper">
                    <mat-option class="option-list" *ngFor="let item of toolsData" [value]="item.id">{{ item.manufacturer.name }} - {{ item.name }}</mat-option>
                </mat-select>
            </div>
        </div>
    </div>
</div>
<div class="modal-footer">
    <button type="button" class="btn primary-ebtn" (click)="Submit()">Select</button>
    <button type="button" class="btn secondary-ebtn" (click)="closeClick()">{{ 'PLANT_MANAGER.Cancel' | transloco }}</button>
</div>
